export default "__VITE_ASSET__DC2_ihoL__"